import type { MouseEventHandler, ReactNode } from 'react'
import React from 'react'
import { Heading } from '../Heading'
import { Button } from '../Button'
import * as Styled from './styled'

export type EmptyStateProps = {
  title: string
  subtitle?: ReactNode
  label?: string
  href?: string
  to?: string
  disabled?: boolean
  onClick?: MouseEventHandler<HTMLButtonElement>
  variant?: 'primary' | 'secondary'
}

export const EmptyState = ({
  title,
  subtitle,
  label,
  href,
  to,
  disabled = false,
  variant = 'primary',
  onClick,
}: EmptyStateProps) => {
  return (
    <Styled.Container>
      <Heading type={variant === 'primary' ? 'h3' : 'h7'} asTag="h2" weight="bold">
        {title}
      </Heading>
      {subtitle && <Styled.Subtitle>{subtitle}</Styled.Subtitle>}
      {label && variant === 'primary' && (
        <Styled.ButtonWrapper>
          <Button
            label={label}
            to={to}
            href={href}
            appearance="primary"
            size="medium"
            disabled={disabled}
            onClick={onClick}
          />
        </Styled.ButtonWrapper>
      )}
    </Styled.Container>
  )
}
